(function () {
    'use strict';

    angular
        .module('procedureControllers')
        .controller('ProcedureEditReviewersController', Controller);

    Controller.$inject = ['$scope', '$state', '$window', 'procedureService', 'modalService', 'notificationService', 'procedure'];

    function Controller($scope, $state, $window, procedureService, modalService, notificationService, procedure) {

        $scope.procedure = procedure;

        $scope.ctxtCtrl = {
            isLoading: false,
            isDirty: false,
            potentialReviewers: []
        };

        // Keep initial to revert on cancel without reloading
        var initialReviewerBlock = _.cloneDeep($scope.procedure.ReviewerBlock);

        init();

        $scope.reviewerChanged = function (reviewer) {
            $scope.ctxtCtrl.isDirty = true;
            var attributeId = reviewer.TypeCode === 'BusinessUnit' ? 'BusinessUnitID' : 'CommitteeID';
            var matchObj = {};
            var removedReviewer;

            matchObj[attributeId] = reviewer[attributeId];

            if (reviewer.IsReviewer) {
                removedReviewer =_.remove($scope.procedure.ReviewerBlock.ExcludedReviewers, matchObj);
                $scope.procedure.ReviewerBlock.Reviewers.push(removedReviewer[0]);
            } else {
                removedReviewer =_.remove($scope.procedure.ReviewerBlock.Reviewers, matchObj);
                $scope.procedure.ReviewerBlock.ExcludedReviewers.push(removedReviewer[0]);
            }
        };

        $scope.deleteExternalCommittee = function (reviewer) {
            $scope.ctxtCtrl.isDirty = true;
            $scope.procedure.ReviewerBlock.ExternalReviewerCommittees =
                _.reject($scope.procedure.ReviewerBlock.ExternalReviewerCommittees, {
                    CommitteeID: reviewer.CommitteeID
                });
        };

        $scope.deleteExternalPerson = function (person)
        {
            $scope.ctxtCtrl.isDirty = true;
            $scope.procedure.ReviewerBlock.ExternalReviewerPeople =
               _.reject($scope.procedure.ReviewerBlock.ExternalReviewerPeople, {
                   ItemPersonID: person.ItemPersonID
               });
        };

        $scope.addExternalPerson = function (person) {
            $scope.ctxtCtrl.isDirty = true;
            $scope.procedure.ReviewerBlock.ExternalReviewerPeople.push(person);
        };

        $scope.addExternalCommittee = function () {
            $scope.ctxtCtrl.isDirty = true;
            procedureService
                       .getAllCommittees()
                       .then(function (committees) {

                           var availableCommittees = _.differenceBy(committees, $scope.procedure.ReviewerBlock.ExternalReviewerCommittees, 'CommitteeID');
                           modalService.displayTemplateModal(
                               'Select a Committee',
                               require('../../shared/procedure/referenceType/prcCommittee.modal.tpl.html'),
                               {
                                   availableCommittees: availableCommittees,
                                   placeholderText: committees.length ? 'Select a Committee' : 'No available Committee',
                                   minHeight: '260px',
                                   selection: {
                                       selectedCommittee: null
                                   }
                               },
                               function (scope) {
                                   if (scope.selection.selectedCommittee) {
                                       $scope.procedure.ReviewerBlock.ExternalReviewerCommittees.push(scope.selection.selectedCommittee);

                                       return true;
                                   }
                               },
                               true,
                               function () {

                               }
                           );

                       });
        };

        // Cancel
        $scope.cancel = function () {
            $scope.procedure.ReviewerBlock = initialReviewerBlock;
            $window.history.back();
        };

        // Save
        $scope.save = function () {
            if (!$scope.ctxtCtrl.isDirty) return;

            $scope.ctxtCtrl.isLoading = true;

            procedureService
                .updateReviewers(
                    $scope.procedure.MetadataBlock.ProcedureType.Value,
                    $scope.procedure.ProcedureID,
                    $scope.procedure.ReviewerBlock)
                .then(function () {
                    notificationService.notify('Reviewers updated successfully');
                    $state.go('^');
                })
                .finally(function () {
                    $scope.ctxtCtrl.isLoading = false;
                });
        };

        function init() {
            _.each($scope.procedure.ReviewerBlock.Reviewers, function (reviewer) {
                reviewer.CSSIcon = typeCodeToCssIcon(reviewer.TypeCode);
                reviewer.IsReviewer = true;
                $scope.ctxtCtrl.potentialReviewers.push(reviewer);
            });

            _.each($scope.procedure.ReviewerBlock.ExcludedReviewers, function (reviewer) {
                reviewer.CSSIcon = typeCodeToCssIcon(reviewer.TypeCode);
                reviewer.IsReviewer = false;
                $scope.ctxtCtrl.potentialReviewers.push(reviewer);
            });

            $scope.ctxtCtrl.potentialReviewers = _.orderBy($scope.ctxtCtrl.potentialReviewers, 'TitleEN');
        }

        function typeCodeToCssIcon(typeCode) {
            if (typeCode === 'BusinessUnit') {
                return 'fa-university';
            }
            if (typeCode === 'Committee') {
                return 'fa-users';
            }
            if (typeCode === 'CorporateRole') {
                return 'fa-tag';
            }
            return undefined;
        }
    }
})();
